// @ts-check

// Sibling imports
const { reload } = require('./actions')

/** @typedef { import('redux').Store } ReduxStore */

/**
 * This is necessary to prevent buggy "Back button" behavior when
 * navigating from a client-v2 endpoint back to a wiggin endpoint.
 * @see https://app.asana.com/0/102902769366319/762136202375174/f
 * This will likely need to be revised/removed as part of:
 * @see https://app.asana.com/0/102902769366319/681203866231475/f
 * @param {ReduxStore} store
 */
function configureBrowserNavigation(store) {
  window.addEventListener('pageshow', event => {
    if (isBackForwardNavigation(event)) {
      store.dispatch(reload())
    }
  })
  window.addEventListener('popstate', () => {
    if (isWindowLocationOutOfSyncWithReduxStore(store)) {
      store.dispatch(reload())
    }
  })
}

/**
 * @param {PageTransitionEvent} event
 * @returns {boolean}
 */
function isBackForwardNavigation(event) {
  if (typeof window.performance !== 'undefined') {
    const { type } = window.performance.navigation
    return type === PerformanceNavigation.TYPE_BACK_FORWARD
  }
  return event.persisted
}

/**
 * @param {ReduxStore} store
 * @returns {boolean}
 */
function isWindowLocationOutOfSyncWithReduxStore(store) {
  const { router } = store.getState()
  // Decode the pathnames to work-around encoding inconsistencies
  const routerPathname = decodeURIComponent(router.location.pathname)
  const windowPathname = decodeURIComponent(window.location.pathname)
  return routerPathname !== windowPathname
}

module.exports = {
  configureBrowserNavigation
}
